import {
    Component,
    EventEmitter,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import {
    BehaviorSubject,
    filter,
    lastValueFrom,
    Subject,
    takeUntil,
} from 'rxjs';
import { FamilyAccessComponent } from 'src/app/modals/family-access/family-access.component';
import { HttpNewService } from 'src/app/services/application/http-new.service';
import { CookieConsentService } from 'src/app/services/cookie-consent-service';
import { Store } from 'src/app/services/store.service';
import { IPatient } from '../../../interfaces/patient';
import { StatementComponent } from '../../../modals/statement/statement.component';
import { LoadService } from '../../../services/application/load.service';
import { AuthService } from '../../../services/auth.service';
import { PatientService } from '../../../services/patient.service';
import { Size } from '../../../services/size';
import { FeedbackComponent } from '../../feedback/feedback.component';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
    @Output() patientNameChange = new EventEmitter<string>();
    btnDropUP = false; // Статус кнопки
    public patient!: IPatient | null;
    public periodTest: string = '';
    public deviceType: string = '';
    //отловить сслыку
    public routerDynamicLink: string = '';
    public strFirst: string = '';
    private _setting: any;
    public AccessStatement = false; // Доступ к стрпавке в налоговую
    public withFeedback: boolean = false;
    public pricelistExternalUrl: string = '';
    public isWorkPersonalData = true;
    withFamilyAccess: boolean = false;
    isMainAccount: boolean = true;
    patientName: string = '';
    private _displayFullName: boolean = true;
    private resizeListener: (() => void) | undefined;
    @ViewChild('btnDropDown', { static: false }) btnDropDown!: NgbDropdown;

    constructor(
        private router: Router,
        private cookieService: CookieConsentService,
        private auth: AuthService,
        private patientService: PatientService,
        private httpService: HttpNewService,
        private dialog: MatDialog,
        public size: Size,
        private load: LoadService,
    ) {
        this.router.events
            .pipe(
                filter(
                    (event): event is NavigationEnd =>
                        event instanceof NavigationEnd,
                ),
                takeUntil(this.destroy$),
            )
            .subscribe((event: NavigationEnd) => {
                this.routerDynamicLink = event.url.split('#')[0];
            });
        this.isMainAccount = this.isFamilyAccount();
        this.deviceType = this.size.getDeviceType();

        this._setting = load.configData.pages.personal;
        const loginSetting = load.configData.pages.login;
        if (loginSetting.isRolesSystem) {
            const authConfigSetting = this.load.getAccessUserConfig;
            this.isWorkPersonalData = authConfigSetting.includes(
                'lk_access_patient_data',
            );
        }
        if (this._setting && this._setting.WEB_LK_ACCESS_STATEMENT) {
            if (this._setting.WEB_LK_ACCESS_STATEMENT == 1) {
                this.AccessStatement = true;
            } else {
                this.AccessStatement = false;
            }
        }

        if (
            Object.keys(load.configData.pages.feedback).length !== 0 &&
            load.configData.pages.feedback !== null &&
            load.configData.menu.items.includes('feedback')
        ) {
            this.withFeedback = true;
        }

        if (load.configData.other.familyAccess) this.withFamilyAccess = true;

        if (
            load.configData.links.pricelist &&
            load.configData.links.pricelist.match(/http(s)?:\/\//)
        )
            this.pricelistExternalUrl = load.configData.links.pricelist;
    }
    private destroy$ = new Subject<void>();
    ngOnInit(): void {
        this.deviceType = this.size.getDeviceType();
        this._displayFullName = window.innerWidth >= 769;
        this.patientService.patient$
            .pipe(
                filter((patient): patient is IPatient => !!patient),
                takeUntil(this.destroy$),
            )
            .subscribe({
                next: (patient) => {
                    this.patient = patient;
                    // this.patientName = `${patient.lastname} ${patient.firstname} ${patient.secondname}`;
                    this.patientName = [
                        patient.lastname,
                        patient.firstname,
                        patient.secondname,
                    ]
                        .filter(
                            (part): part is string =>
                                !!part && typeof part === 'string',
                        ) // фильтруем только непустые строки
                        .join(' ');

                    this.patientNameChange.emit(this.patientName);
                    this.patientService.setPatientName(this.patientName);
                },
                error: (err) => {
                    console.error(
                        ' Ошибка в подписке на данные пациента:',
                        err,
                    );
                    this.patient = null;
                },
            });
        this.resizeListener = () => {
            this._displayFullName = window.innerWidth >= 769;
        };
        window.addEventListener('resize', this.resizeListener);
    }
    ngOnDestroy(): void {
        if (this.resizeListener) {
            window.removeEventListener('resize', this.resizeListener);
        }

        this.destroy$.next();
        this.destroy$.complete();
    }

    openChange(event: any) {
        this.btnDropUP = event;
    }
    isFamilyAccount(): boolean {
        const parentCookieName = Store.getDataString('ParentCookieName');
        if (parentCookieName) {
            return false;
        }
        return true;
    }
    async exitFamilyAccount() {
        try {
            const cookieId = Store.getDataString('ParentCookieName');
            // console.log(cookieId);
            await lastValueFrom(
                this.httpService.get('/family/set/cookie', {
                    cookieId: cookieId,
                    isSetParentCookie: 'true',
                }),
            );
        } catch (e) {
            console.error(`Error exit family account: ${e}`);
        } finally {
            Store.deleteStoreNameKey('ParentCookieName');
            window.location.reload();
        }
    }

    onExit() {
        this.auth.logout();
    }
    get hasNoBorderRadius(): boolean {
        return (
            this.router.url.startsWith('/home/rec') ||
            this.router.url.startsWith('/home/record-services') ||
            this.router.url.startsWith('/home/history')
        );
    }

    showStatement() {
        if (this.AccessStatement) {
            // Закрываем dropdown
            this.btnDropDown?.close?.();

            // Откладываем открытие модалки на следующий тик (macrotask)
            setTimeout(() => {
                const dialogRef = this.dialog.open(StatementComponent, {
                    width: window.innerWidth <= 500 ? '100%' : 'auto',
                    minWidth: window.innerWidth <= 500 ? '100vw' : 'none',
                    height: window.innerWidth <= 500 ? '100%' : 'auto',
                    closeOnNavigation: true,
                    data: {},
                });

                dialogRef.afterClosed().subscribe(() => {});
            }, 0);
        }
    }
    goFeedback() {
        if (window.innerWidth <= 500) {
            const dialogRef = this.dialog.open(FeedbackComponent, {
                width: '100%',
                minWidth: '100vw',
                height: '100%',
                closeOnNavigation: true,
                data: {},
                disableClose: true, // Add this to prevent default closing
            });

            // Handle backdrop click
            dialogRef.backdropClick().subscribe(() => {
                // The feedback component will handle its own closing logic
            });

            dialogRef.afterClosed().subscribe((result) => {
                if (result) {
                    // Handle result if needed
                }
            });
        } else {
            const dialogRef = this.dialog.open(FeedbackComponent, {
                maxWidth: '100vw',
                closeOnNavigation: true,
                data: {},
                disableClose: true, // Add this to prevent default closing
            });

            // Handle backdrop click
            dialogRef.backdropClick().subscribe(() => {
                // The feedback component will handle its own closing logic
            });

            dialogRef.afterClosed().subscribe((result) => {
                if (result) {
                    // Handle result if needed
                }
            });
        }
    }
    showFamilyList() {
        if (this.withFamilyAccess) {
            // this.dialog.open(FamilyAccessComponent, {
            //     maxWidth: '100vw',
            //     // width: '100%',
            //     closeOnNavigation: true,
            //     data: {},
            // });

            if (window.innerWidth <= 500) {
                const dialogRef = this.dialog.open(FamilyAccessComponent, {
                    width: '100%',
                    minWidth: '100vw',
                    // maxWidth: '100vw',
                    height: '100%',
                    closeOnNavigation: true,
                    data: {},
                });
                dialogRef.afterClosed().subscribe((result) => {
                    if (result) {
                        // Отмена номерка
                    }
                });
            } else {
                const dialogRef = this.dialog.open(FamilyAccessComponent, {
                    // width: '50%',
                    maxWidth: '100vw',
                    // height: '90%',
                    closeOnNavigation: true,
                    data: {},
                });
                dialogRef.afterClosed().subscribe((result) => {
                    if (result) {
                        // Отмена номерка
                    }
                });
            }
        }
    }

    showPricelist() {
        if (this.pricelistExternalUrl) {
            window.open(this.pricelistExternalUrl, '_blank');
        }
    }

    /*
/!**************************************************** *!/
  test(ev: any){  //формат строки


//    ev = '';
//    this.periodTest = this.periodTest + ev.key;
//    newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2');
    if (this.periodTest.length == 2 || this.periodTest.length == 5){
      this.periodTest = this.periodTest + '.';
    }
//    ev.returnValue = false;
  }

  /!* только числа *!/
  public numberOnly(event: any): boolean {
//    const charCode = (event.which) ? event.which : event.keyCode;


    const charCode = event.keyCode;
/!*
    if (charCode === 48 && event.srcElement.value.length === 0) { // Проверка на первый 0
      return false;
    } else {
*!/
      // Проверка на ввод числа
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
      let testD: number | null = null;  // День
      let testM: number | null = null;  // месяц
      let testY: number | null = null;  // год

      // Проверка на день
      let str = this.periodTest + event.key;
//      let t = Number(str);
//
      if (str.length >1){
        let d = Number(str.substr(0,2));
        

      }
/!*
    }
*!/
    return true;
  }
*/
    getPatientName() {
        return this._displayFullName
            ? this.patient?.firstname
            : this.patient?.firstname?.charAt(0);
    }
}
